module.exports = __webpack_public_path__ + "432b66c92d5549eab7d63d9fee2c4ee1.svg";